import { utilHelper } from "../../_helpers";

const relativeUrl = 'api/queryExecutor'

export const queryExecutorService = {
    search,
};

//search
function search(offset, max, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: data, showAlert:false })
}